import { render, staticRenderFns } from "./ScholarshipDetailPage.vue?vue&type=template&id=d5f971aa&"
import script from "./ScholarshipDetailPage.vue?vue&type=script&lang=js&"
export * from "./ScholarshipDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports